import { render } from "./AutoLabeView.vue?vue&type=template&id=cc1426fa&scoped=true"
import script from "./AutoLabeView.vue?vue&type=script&lang=js"
export * from "./AutoLabeView.vue?vue&type=script&lang=js"

import "./AutoLabeView.vue?vue&type=style&index=0&id=cc1426fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc1426fa"]])

export default __exports__